"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagEvaluationError = void 0;
class FlagEvaluationError extends Error {
}
exports.FlagEvaluationError = FlagEvaluationError;
//# sourceMappingURL=flag-evaluation-error.js.map